var _path, _path2, _polygon, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCar({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 750 500",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "freepik--background-complete--inject-127"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 131.13,
    cy: 136.5,
    r: 37.98,
    transform: "translate(-31.85 232.76) rotate(-76.72)",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M126.19,148.35a6.2,6.2,0,1,1-6.19-6.19A6.2,6.2,0,0,1,126.19,148.35Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M117.4,130.48a3.6,3.6,0,1,1-3.6-3.61A3.6,3.6,0,0,1,117.4,130.48Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M94.28,145.73c.17.66-32.51,32-24.08,38.7s43.85-10.46,74.06-34.86,57.8-54,50.24-61.86-45.3,15.38-45.3,15.38l4.52,2.87s22.82-14.64,30-9-13.36,27.89-42.41,49.09-57.1,36.08-61.46,30.28,16.2-25.19,16.2-25.19Z",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 635.03,
    cy: 384.21,
    r: 31.33,
    transform: "translate(-97.57 503.29) rotate(-40.41)",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M639.34,374.53a5.11,5.11,0,1,1,5,5.23A5.09,5.09,0,0,1,639.34,374.53Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M646.23,389.44a3,3,0,1,1,2.9,3.05A3,3,0,0,1,646.23,389.44Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 376.04,
    cy: 252.13,
    r: 171.22,
    transform: "translate(-68.14 339.75) rotate(-45)",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M522.6,193.33c-1.41-1.71-1.6-7.32-5-4.11.23-2.82-.9-9.54,4.11-8.92,5.46.69,3,6.61,4.23,9.65,1.49,3.56,6.46,3.85,9.3,5.87,1.92,1.37,3.07,3.4,4.16,5a170.92,170.92,0,0,0-34.71-61.58c0,.13,0,.27,0,.41-3.62-.25-6.88,4.58-6.21,7.61.11.51,1.58,1.4,1.76,2.5s-.77,1.57-.8,2.43c-.08,2-.6,3.91,2.11,4.45,1.75-3.34,5.68.62,6.48,2.84,1.4,3.89-.3,5.85,2.46,9,1.07,1.22,4.25,2.72,3.61,4.87s-2.25,1.74-3.82,1.14c-2.53-1-3.89-4.78-6.86-4.89-2,4.94-.13,11.34-1.69,16.6-.87,2.93-1.94,3.05.59,5.22.91.78,1.53-.09,2.6,1.17.63.75.64,2.36.57,3.28,1.4-.85,2.64-2.16,4.43-2-2.68,2.31-2.26,6.62-4.12,9.56-2.33,3.68-4.27,2.45-7.47,3.92-5.59,2.58-2.7,7.6-3.3,11.76-.34,2.43-2.35,4.48-3.3,6.81a28.46,28.46,0,0,0-2.26,10.3c-.07,4.18,1.27,8,2.07,12,.64,3.28.65,9.57,3.86,11.47,2,1.15,8.17.93,10.79,1.32s5.7-1,7.91.14,1.88,4.61,4.71,3.81c1.59-.45,2.51-4.18,4.5-4.88,3.19-1.12,5.71,1.8,6.59,4.31,1.12,3.18-.54,3.3-1.4,6.7-.68,2.68,0,5.52.86,8,1.78,5.07-.19,2.85-2,7.57a14.12,14.12,0,0,0,4.09.46c.1,1.81.49,4.48.07,6.26-1.17,5-6,7.71-6.24,13.48-.23,5.27,2.19,11.63,1.19,16.79-.73,3.79-5,6.25-4.3,10.63,2.39-1.54,4.21-4,6.83-5.26a171.19,171.19,0,0,0,12.28-122,23.43,23.43,0,0,1-7.78-5.65C530.51,198.26,525.3,196.58,522.6,193.33Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M398.76,85.8c2.1.38,4.47.35,6.55.86,2.35.57,4,2.18,6.58,1.16a6.88,6.88,0,0,0,2.88-2.46A171,171,0,0,0,290.22,104c6.55.41,5.08,7.76,10.72,1.71,2.51-2.7,5.3-6.39,8.5-8.75,3.58-2.65,7.68-.86,12-1-1.44,1-9.49,6.82-8.6,8.71,1.23,2.61,5.69-.55,3.94,4.48-1.56,4.48-7.94,1.43-11.89,1.73-3.06.24-4.73,2.29-8,2.45-3.47.17-6.95-.81-10.33-.71-5.4.16-8.86,3.27-12.15,7.06-1.9,2.2-4.16,3.84-5.55,6.49-1.52,2.9-.91,6.69-2.33,9.29-1.22,2.24-4,2.61-6,3.94a41.21,41.21,0,0,0-7.2,6.58c-3.21,3.73-4.65,10.83-10.13,12.18-.78,5.77,8-2.27,10.56-1.12,1.33-1.76,1.85-4.09,3.82-5.41s4.75-1.09,7-2.53c4.29-2.74,2.91-8.75,8.26-9.77,4.32-.82,9.16-1.66,10.22,3.09.53,2.36-.39,2.14-.46,4.42-.1,3-.34,1.18,1.94,3,3.44,2.83,4,6.24,1.31,10.23-1.29,1.89-2,1.63-2.79,4.08s-.51,5.08-.42,7.65c.09,2.87-.19,5.66-.28,8.53-.15,4.78,1,6.56,4.78,9.57,2.87,2.29,5.93,4,7.41,7.55,1.28,3.1,1,6.81,1.89,10,.88,3.33,9.17,10.29,8.26,4.36-.47-3.06-3.95-3.75-3.93-7.48,0-1.51.62-3.73.78-5.32,4.75-1.3,3.5,6.8,4.77,9.22,1.81,3.43,6.54,5.64,9,8.36-2.29,1.07-6.15,3.31-4.88,6.48,1.62,4,6.73,1.21,9.55,1.28,6.16.14,12.28,4.26,17.3,7.55,4.78,3.13,6.71,5,12.73,4.55a19,19,0,0,1,10.88,2.14,11.59,11.59,0,0,1,5.69,5.59c1.91,3.63,2.77,4.92,6,7.39,2.1,1.61,3.2,3.36,5.53,3.24,1.6-.07,2.76-2.41,5.2-1.65,4.64,1.44,3.29,7.34,1.77,10-1.28,2.28-2.48,5.22-3.9,7.48-1.82,2.88-6.58,3.95-7.13,7.75-.52,3.61,3.5,7.74,4.39,11.15.81,3.09.72,6.5.72,9.66-2,2.92,10.16,13.24,12.43,15.22,3.32,2.89,8.16,6.73,9.45,11.14.53,1.81.22,4.65.4,6.56a86.29,86.29,0,0,1,.29,12.15c-.27,5.91-4.52,9.52-5.52,15.12-.81,4.49.79,9.21.11,13.65-.31,2-.7,4.84-1.2,6.8s-1.46,1.94-2.25,3.33c-1.42,2.48-.7,4.93.5,7.61,3.76-2.71,6.88,2.41,8.65,5,2.21,3.24,4.85,4.53,9.43,4-1.8-1.48-4.83-6.32-4.21-9,.91-3.91,6.55-7.07,8.45-10.34,2.05-3.53,1.47-6.83,5.71-8.4,1.19-.44,2.59-.22,3.78-.71,1.48-.61,2.27-2,3.71-2.69,3.94-1.87,4.84-1.37,6.48-5.76,2-5.31,3.7-12,8.75-15.4,2-1.33,4.17-1.24,6.33-2.17,2.37-1,3.11-2.64,5-4a38.76,38.76,0,0,0,7.65-6.85,56.79,56.79,0,0,0,6.84-10.2c1.27-2.29,1.82-4.42,3.74-6.26.81-.78,2.05-1.09,3-2,3.47-3.46,4.77-9,7.78-12.79,1.69-2.14,3.36-3.35,4.29-5.82a11.54,11.54,0,0,0-1.36-2.34c-.73-1.33-2.52-2.56-3.41-3.93-.31-.48-.42-2-.73-2.29-2.49-2.66-8.52-4.06-11.88-4.2-4.59-.18-11.47-.89-14.47-5-2.23-3.09,1.59-7.48.12-10.77-1.82-4.11-11.38-6.09-15.05-8.32-2.53-1.54-4.24-3.88-6.75-5.45-3.67-2.29-5.87-3.24-7.43-7.28-.94-2.42.5-2.83-2.43-3.75-2.73-.85-7,1.53-10.06,1.77-2.27.18-4.83.65-7,0-2.7-.81-4.69-3.87-7.5-4.39-2.53-.48-7.52.71-9.84,2.24-2,1.28-3,3.59-5.16,4.59-3.12,1.45-2.9-.45-5.92-.71s-4.58,1.39-6.89-2c-3.13-4.64-1.86-14.12-9.23-14.6-2.19-.14-6.41,1.7-7.76-1.11-2-4.14,5.16-9.63,4.13-14.11-1.08-4.66-9.78,1.47-11.74,4-1.25,1.65-2.24,5.68-4.87,6-2,.21-6.05-2.4-7.25-3.85-2.09-2.53-2.22-7.44-2.52-10.63-.57-6,.81-7.87,5-12.35,3.7-4,4.46-4.3,9.2-5.13,2.91-.51,2.88-1.54,5.35-.25,1.18.62,1.91,2.46,3.35,3.05,2-2,3.37-2.58,6.07-2.05,1.94.39,6,2.64,7.07,4.46.65,1.11,1.67,11.08,5.26,5-2.09-1.72-1.53-3.75-2.38-5.66s-2.79-3.3-3.15-5.69c-.43-2.78,2-8.57,5.17-9.18l-.34-3.12c3.51-.49,7.68-9,7-13.19-.36-2.09-2.63-1.93-1.42-4.94,1.42-3.52,3.87-1.68,6.85-2.33s2.55-2.61,4.68-4.19c2.32-1.74,3.41-.41,5.38-.32,3.7.16,8.55,1,8.82-4.14,2.26-.31,4.23-1,6.49-.06.3-4-.59-6.92-4-9.23-3-2-7-2.64-10.14-4.63-2-1.28-3.45-3.14-5.36-4.5-3.08-2.2-5.2-4.63-8-7.11-3.55-3.16-7,.83-11.67.18-6.23-.88-5.83-5.57-9.68-8.35-.44-.32-1.71.11-2.28-.17a16.75,16.75,0,0,1-2.76-2.59,14.49,14.49,0,0,1-4-8.35c6.87-4,8.61,5.46,11.48,8.88,1.3,1.55,6.41,2.52,2.41,5,2.77.19,5.23-.22,7.82.4,1.22.28,2.26,1,3.59,1,.27-2.13-.49-4.22-.91-6.27-.2-.94.07-1.91-.32-2.82-.57-1.33-2-2-2.51-3.09-1.52-3.17.38-3.17-3.08-5.08-2.38-1.31-5.25-2.25-7.71-3.36a15.65,15.65,0,0,1-4.81-2.71c-.61-.61-4.48-4.68-4.77-5.42-2.74-6.79,7.92-.62,10.36,0a99.37,99.37,0,0,1,11.79,3.93c3.14,1.2,3.19,1.9,4.4,5,2.18,5.68,5.24,3,8.71,6.77,2.09,2.28,3.72,6.4,5.52,9.1,2.27,3.42,11.19,14.1,16.17,9,2.67-2.75-2.49-7.56-2.59-10.24-.11-2.85,1.82-4.61,3.79-6.16,3.31-2.61,4.08-3.69.16-6.85-4.81-3.89-10.1-4.52-15.84-6.34-6.23-2-7.89-5.58-11.05-10.63,2.08-.38,4.27-.55,6.4-.74A21,21,0,0,1,398.76,85.8Zm-63.48,43.9c-.81,2.13-2.3,1.47-3.69,2.56-2.14,1.67,1.64,4.64.11,5.73-.54.39-3.49.23-4.16,0-1.71-.57-2.24-1.78-4.24-1.76-2.63,0-5.27-.49-4.69-3.8.27-1.55,1.84-3.09,1.1-4.79A9.87,9.87,0,0,0,317,125c-.69-.48-1.55-.41-2.15-.79-1.37-.85-.85-4.21.66-4.8.05,4.64,6.93.45,8.36,2.58s-1.42,3,.38,4.35c1.05.82,3.81.82,4.86.51,1.62-.47,4.32-2.91,5.92-1.14C335.65,126.48,335.61,128.84,335.28,129.7Zm22.05-8.16c1.71.49,1.41,1.31,2.3,2.66,1,1.53,2.71,1.39,3.92,2.5,2.29,2.11-1.33,4.89,0,7.5,1.17,2.27,14.25,5.67,5.71,8.45-2.5.81-4-.83-6.25-1.47a12,12,0,0,0-7.3.8c-4.17,2.42,5.17,6.91-.59,8.65-1.17.36-5,.13-5.36-1.32-.36-1.28,1.44-1.26,1.81-2.49,1.47-4.84-4.47-1.85-6.13-2.27-2.34-.6-1.61-4.8.25-5.75,1-.51,3.55-.24,4.67-.26,1.83,0,3.66.25,5.49.09.85-3.52-4.43-5.3-7.2-5.68-2.18-.29-2.47-.73-4.27-2-2.17-1.58-3.12-1.14-1.6-4,1.33-2.52,3.5-3.86,5.66-5.56,1-.5,1.81.55,2.8.66C353.27,122.21,355.33,121,357.33,121.54Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M372.39,210.84c-1.95-.68-8.9,1.83-6.05,3.88,1.93,1.4,6.51-.4,8.87.15s5.29-.33,7.6.61c1.71.7,2.64,2.28,4.54,2.75,2.31.58,3.53-.36,1.38-2.15-1.51-1.26-3.61-1.6-5.37-2.42-1.33-.61-2.53-1.81-3.86-2.17C377.73,211,373.78,212.62,372.39,210.84Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M396.67,221.25c-1.71,1.08-3.34,1.62-3.91,3.82-.67,2.58.4,2.1,2.14,1.1,1.1-.64,2.62-1.72,4-1.65s2.45,1.06,3.75,1.29a7.88,7.88,0,0,0,6.61-1.51c1.43-1.25,1.54-2.87-.69-3.23-1.69-.27-4.4.56-6.16.74S397.62,222.1,396.67,221.25Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M477.62,385.65c-3.92,2.69-6.3,6.37-10.93,8.28-5,2.06-9.74,4.91-14.9,7s-10.79,5.32-16.14,6.62c-4.47,1.09-9.5-1-14-.91a60.75,60.75,0,0,0-13.82,2.27c-3.11.8-3,.23-5.43-.7a9.64,9.64,0,0,0-3.73-.94,42.7,42.7,0,0,1-4.58-.34c-.08,2.15,4.67,6.51,6.47,7.88-14,1.21-28.9-.56-42.81-2-4.1-.42-6.53,1.36-10.44,1.86-3.61.47-6.67-1.48-10.31-1.51-4.38,0-6.3.87-8.17,3.6a171.09,171.09,0,0,0,156.89-33.15,12.23,12.23,0,0,0-.13-1.63C483.33,382.86,479.68,384.23,477.62,385.65Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M210.12,253.84a10.4,10.4,0,0,0,.77-5.53c-.46-1.94-1.37-1.77-2.26-3.32-2.47-4.27,1.21-4.78,1.2-8.37,0-2.1-4.36-7.1-1.47-9.24,1.3-1,6,1.38,8.39.39-.42-3.45-3.81-2.4-5.19-4.74-2.06-3.51,1.36-4.24,2.42-5.8,3.44-5-1.43-7.61-2.67-11.75a171,171,0,0,0-6.49,46.65c0,.61,0,1.22.05,1.84C206.12,252.87,207.75,252.56,210.12,253.84Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M215.76,205.24c1.72-.54,1.05-4.74,1.37-5.88a40,40,0,0,1,5-10c2.83-4.22,1.57-5.79.94-10.94-.11-.87-.17-1.82-.24-2.75a170,170,0,0,0-10.5,26.1C213.32,203.2,214.57,205.62,215.76,205.24Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M211.93,233.39c-2.66,7.84,5.73,9,5.9,15.44.06,2.39-1.17,10.62,3.83,10,2-4.56-1.22-5.19-.64-9.42.39-2.86,2.45-3.68-.75-6-.88-.66-2.45-.68-3.16-1.37-1-.95-.8-2.25-1.4-3.2C214.64,237.11,213,236,211.93,233.39Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M211.93,260.45c-2.12,4.67-6,21.49,1.54,21.8.84,0,2.38-1.5,3.24-.93.68.45.09,2.2.4,2.38,1.95,1.1,2.45,1.37,3.23-2,.62-2.67-.74-2.78-1.13-4.6a16.82,16.82,0,0,1-.05-4.81c-4.89-1.2,5-2.24,4.6-4.21-.29-1.5-7.6-1.07-8.65-.74a12.49,12.49,0,0,1,.22-4.06C213.7,262.55,213.2,260.83,211.93,260.45Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M236.56,275.72c-4.26.25-6.49-3.63-11.49-2.11,0,1-.27,2.16-.27,3.11,1.13-.34,6.37-1.57,5.53,1.45-.7,2.52-5.26-.67-4.47,3.05,1.3-.15,3.35-1.12,4.63-1,1.86.24,2.59,1.24,4.34,1.63,2.32.5,2-.65,4.48,1.1,1.92,1.36,3.91,3.45,4.54,5.56,1.35,4.48-.65,6.25,5.1,6.95,3,.37,9.35,3.64,9.16-1.29,2.86,1,7.24,9.48,11.07,8.62,4.8-1.07-4.49-8.54-4.46-9.37,1.89-.17,6.09-2,7.54-2.84s3-.72,2.42-3.75c-2.27-.27-3.27.83-5,1.28a20,20,0,0,1-6.35.33,24.67,24.67,0,0,1-14.19-5.84c-2.29-1.88-4.25-3.44-6.64-5.21-1.56-1.15-1.51-1.88-3.3-2.4A2.78,2.78,0,0,0,236.56,275.72Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M212.62,286.82c3.06,0,6.33.37,9.37,0,1-.13,2.25-1.81,3.42-.63.42.43.09,3.13-.29,3.55-1.85,2.06-12.05,1.4-11.46-2.58",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M259.45,310.8c-.29-5.39-2.37-4.65-4.86-8.1-.86,2.23-1.82,6.7-4.83,7-4.45.48-5.16-6.17-7.82-8-3.81-2.6-12.47-.07-13.36,3.47-3.54,1.39-3.77,3.06-5.2,6a48.15,48.15,0,0,1-3.56,6.11,19.06,19.06,0,0,1-1.39,1.76,171.19,171.19,0,0,0,11.5,22.29,4.81,4.81,0,0,0,1.24.23c3.77.3,5.78-3.86,8.79-3.47,2.19.28,3.79,4,5.59,5.46,5,4.12,13.36,7.18,15.3,13.27,1.18,3.69,2.64,5.29,4.95,8.46,1.62,2.21,1.29,6.13,3.67,7.48a47.57,47.57,0,0,1,1.35-10.32c1.17-4.23-.07-7.73,1.89-11.49s5.09-6.86,4.74-11.55c-.24-3.19-2.61-7.22-4.88-9.51C266.08,323.41,260,321,259.45,310.8Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M302.83,347.19c-2.78.53-1.82,5.94-2.61,8.15-1.11,3.11-2.22,2.79-5.48,3.64a40.56,40.56,0,0,0-6.13,1.73c-3,1.4-3.26,3.9-4.14,6.9,3.74.31,5.89-4.06,9.25-4.76,2.89-.59,5.26.71,8.26-.6,7.53-3.28,5.66-10.7,6.69-16.74C306.44,345.11,304.91,346.45,302.83,347.19Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M306,315.62c-1,2.23,0,7.56,3.29,4.33,1.52-1.5,1.4-5.18-1.5-5,0,.46-.22.59-.4,1",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M330.58,321.17c-2.71,2.13,3.13,5.74,4.09,2.35.71-2.45-3.2-3.26-4.09-2.35",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M286.87,262.19c.79,2,5.91,3.6,6.86,6.92.87,3.06,0,5.73,4.54,5.86-.11-2.19,1.09-5.06.07-7-.46-.87-2-1-2.55-2s-.15-2.19-.6-3.13C294.23,260.88,285.83,256.26,286.87,262.19Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      mixBlendMode: "multiply"
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M416.8,415.41A175.62,175.62,0,0,1,329.65,87.32,171.22,171.22,0,1,0,429,415C425,415.23,420.92,415.41,416.8,415.41Z",
    style: {
      fill: "#fafafa"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M406,458.77l.56,1a6.72,6.72,0,0,0,2.71,2.68l1,.55-1,.56a6.6,6.6,0,0,0-2.71,2.68l-.56,1-.56-1a6.64,6.64,0,0,0-2.7-2.68l-1-.56,1-.55a6.76,6.76,0,0,0,2.7-2.68Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M204.82,419.1l.56,1a6.72,6.72,0,0,0,2.71,2.68l1,.56-1,.55a6.72,6.72,0,0,0-2.71,2.68l-.56,1-.55-1a6.85,6.85,0,0,0-2.71-2.68l-1-.55,1-.56a6.85,6.85,0,0,0,2.71-2.68Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M235,108.85l.55,1a6.78,6.78,0,0,0,2.71,2.68l1,.56-1,.55a6.85,6.85,0,0,0-2.71,2.68l-.55,1-.56-1a6.72,6.72,0,0,0-2.71-2.68l-1-.55,1-.56a6.66,6.66,0,0,0,2.71-2.68Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M659,278.46l1,1.74a11.59,11.59,0,0,0,4.63,4.63l1.74.95-1.74,1a11.57,11.57,0,0,0-4.63,4.62l-1,1.75-.95-1.75a11.63,11.63,0,0,0-4.63-4.62l-1.74-1,1.74-.95a11.65,11.65,0,0,0,4.63-4.63Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M554.45,104.61l.55,1a6.85,6.85,0,0,0,2.71,2.68l1,.55-1,.56a6.85,6.85,0,0,0-2.71,2.68l-.55,1-.56-1a6.85,6.85,0,0,0-2.71-2.68l-1-.56,1-.55a6.85,6.85,0,0,0,2.71-2.68Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M448.3,58.68l.55,1a6.85,6.85,0,0,0,2.71,2.68l1,.55-1,.56a6.85,6.85,0,0,0-2.71,2.68l-.55,1-.56-1A6.79,6.79,0,0,0,445,63.48l-1-.56,1-.55a6.79,6.79,0,0,0,2.71-2.68Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M106.48,333.78l1,1.74a11.59,11.59,0,0,0,4.63,4.63l1.74,1-1.74.95a11.65,11.65,0,0,0-4.63,4.63l-1,1.74-1-1.74a11.65,11.65,0,0,0-4.63-4.63l-1.74-.95,1.74-1a11.59,11.59,0,0,0,4.63-4.63Z",
    style: {
      fill: "#ebebeb"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Stars--inject-127"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 597.34,
    cy: 142.16,
    r: 25.23,
    transform: "translate(-3.16 14) rotate(-1.34)",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M605.56,132.5a4.12,4.12,0,1,1,4,4.21A4.13,4.13,0,0,1,605.56,132.5Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M613.79,142.1a2.4,2.4,0,1,1,2.34,2.45A2.38,2.38,0,0,1,613.79,142.1Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M610.58,149.45a.89.89,0,1,1-.9.86A.88.88,0,0,1,610.58,149.45Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M117.4,209l.56,1a6.71,6.71,0,0,0,2.68,2.68l1,.55-1,.56A6.71,6.71,0,0,0,118,216.5l-.56,1-.55-1a6.77,6.77,0,0,0-2.68-2.68l-1-.56,1-.55a6.77,6.77,0,0,0,2.68-2.68Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M316.63,151.06l.55,1a6.77,6.77,0,0,0,2.68,2.68l1,.55-1,.55a6.74,6.74,0,0,0-2.68,2.69l-.55,1-.55-1a6.74,6.74,0,0,0-2.68-2.69l-1-.55,1-.55a6.77,6.77,0,0,0,2.68-2.68Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M246.69,126.36l.27.5a3.39,3.39,0,0,0,1.34,1.34l.51.28-.51.28A3.39,3.39,0,0,0,247,130.1l-.27.5-.28-.5a3.32,3.32,0,0,0-1.34-1.34l-.5-.28.5-.28a3.32,3.32,0,0,0,1.34-1.34Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M535.27,142.43l.28.51a3.39,3.39,0,0,0,1.34,1.34l.5.27-.5.28a3.32,3.32,0,0,0-1.34,1.34l-.28.5-.27-.5a3.39,3.39,0,0,0-1.34-1.34l-.51-.28.51-.27a3.45,3.45,0,0,0,1.34-1.34Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M601.63,227.15l.28.5a3.39,3.39,0,0,0,1.34,1.34l.51.28-.51.28a3.39,3.39,0,0,0-1.34,1.34l-.28.5-.27-.5a3.39,3.39,0,0,0-1.34-1.34l-.51-.28L600,229a3.39,3.39,0,0,0,1.34-1.34Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M514.07,433.49l.28.51a3.39,3.39,0,0,0,1.34,1.34l.5.27-.5.28a3.39,3.39,0,0,0-1.34,1.34l-.28.51-.27-.51a3.45,3.45,0,0,0-1.34-1.34l-.51-.28.51-.27A3.45,3.45,0,0,0,513.8,434Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M606.47,349.81l.27.51a3.45,3.45,0,0,0,1.34,1.34l.51.27-.51.28a3.39,3.39,0,0,0-1.34,1.34l-.27.5-.28-.5a3.32,3.32,0,0,0-1.34-1.34l-.5-.28.5-.27a3.39,3.39,0,0,0,1.34-1.34Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M391.6,373.58l.28.51a3.39,3.39,0,0,0,1.34,1.34l.5.27-.5.28a3.32,3.32,0,0,0-1.34,1.34l-.28.51-.27-.51A3.39,3.39,0,0,0,390,376l-.51-.28.51-.27a3.45,3.45,0,0,0,1.34-1.34Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M257.39,349.81l.27.51a3.45,3.45,0,0,0,1.34,1.34l.51.27-.51.28a3.39,3.39,0,0,0-1.34,1.34l-.27.5-.28-.5a3.39,3.39,0,0,0-1.34-1.34l-.51-.28.51-.27a3.45,3.45,0,0,0,1.34-1.34Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.72,224.93l.28.5a3.39,3.39,0,0,0,1.34,1.34l.51.28-.51.27A3.41,3.41,0,0,0,71,228.67l-.28.5-.27-.5a3.41,3.41,0,0,0-1.34-1.35l-.51-.27.51-.28a3.39,3.39,0,0,0,1.34-1.34Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M306.84,381.4l1,1.74a11.72,11.72,0,0,0,4.63,4.63l1.74,1-1.74.95a11.72,11.72,0,0,0-4.63,4.63l-1,1.74-.95-1.74a11.72,11.72,0,0,0-4.63-4.63l-1.74-.95,1.74-1a11.72,11.72,0,0,0,4.63-4.63Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M490.73,194.29l1,1.74a11.59,11.59,0,0,0,4.63,4.63l1.74,1-1.74,1a11.59,11.59,0,0,0-4.63,4.63l-1,1.74-1-1.74a11.59,11.59,0,0,0-4.63-4.63l-1.74-1,1.74-1a11.59,11.59,0,0,0,4.63-4.63Z",
    style: {
      fill: "#455a64"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Starman--inject-127"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M590.19,396.23c0,.14-24.6-3.1-54.9-7.25s-54.84-7.63-54.82-7.77,24.59,3.1,54.9,7.25S590.21,396.09,590.19,396.23Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M237.27,179.41c0,.14-19.59-3.18-43.68-7.42S150,164.2,150,164.05s19.58,3.18,43.69,7.42S237.29,179.26,237.27,179.41Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M182.76,159.69c0,.14-12.2-2.06-27.18-4.92s-27.12-5.29-27.09-5.43,12.19,2.06,27.18,4.92S182.79,159.55,182.76,159.69Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M613.17,408c0,.14-12.23-1.53-27.26-3.74s-27.2-4.11-27.18-4.25S571,401.52,586,403.73,613.19,407.84,613.17,408Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M399.21,234.41c-.87.77-26.87,3.86-26.87,3.86l-17.81-8.15-6.26,7.08s21,11.69,23.23,12,18.33-1.55,18.33-1.55Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M346.51,235.72v0a63.59,63.59,0,0,1-6.41-2.41c-2.84-1.4-2.72-1.65-2.5-1.95.59-.82,5.09,2.26,4.51,1s-5.94-3.13-5.3-4c.85-1.08,5.51,2.23,5.92,2.48s.79-.34.41-.55c-.56-.29-6.32-3.56-5.5-4.62.46-.59,1.44.32,1.44.32s5.17,3.45,5.54,2.94-2.59-2.65-3.64-3.3-1.16-1.39-.49-1.62c.45-.15,3.71,1.76,4.74,2.42s3.8,2.53,3.18.5-.33-3.83.09-4.26a.66.66,0,0,1,1.08.64,8,8,0,0,0,.22,2.14,5.24,5.24,0,0,0,.63,1.6c.35.57.66,1,.95,1.44a3,3,0,0,1,.55,2.18c-.25,1.14-3.93,5.39-3.93,5.39Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M354.26,230.54l-5.35,6.7a1.13,1.13,0,0,1-1.43.28l0,0a1.13,1.13,0,0,1-.33-1.7l5.39-6.68a1.12,1.12,0,0,1,1.35-.31h0A1.12,1.12,0,0,1,354.26,230.54Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M371.44,249.16c-.06-.06.43-.51,1-1.38a8,8,0,0,0,.74-7.68c-.4-1-.79-1.49-.72-1.54a3.41,3.41,0,0,1,1.06,1.38,7.51,7.51,0,0,1-.78,8.06A3.5,3.5,0,0,1,371.44,249.16Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M350.33,235.07a3.7,3.7,0,0,1,.93.43l2.44,1.33,8.05,4.38,8.11,4.27,2.46,1.3a4,4,0,0,1,.87.54,4,4,0,0,1-1-.36c-.61-.25-1.47-.65-2.54-1.15-2.12-1-5-2.44-8.19-4.14s-6-3.31-8-4.52c-1-.61-1.81-1.12-2.36-1.48A4.07,4.07,0,0,1,350.33,235.07Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M373.16,247a55,55,0,0,1,7.62-1.21,57.92,57.92,0,0,1,7.69-.7,54.7,54.7,0,0,1-7.62,1.21A57.79,57.79,0,0,1,373.16,247Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 337.94,
    y: 222.15,
    width: 4.69,
    height: 14.75,
    rx: 1.96,
    transform: "translate(-53.63 114.15) rotate(-17.68)",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M415.38,251.45l7.12,1.19a6.49,6.49,0,0,0,7.13-4.07l7.1-18.29a6.51,6.51,0,0,0-5-8.77l-.92-.16a14.25,14.25,0,0,0-15.61,8.9l-4.82,12.43A6.5,6.5,0,0,0,415.38,251.45Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M411.69,201.91a3.89,3.89,0,0,0-6.12,3.27c0,.88.2,1.24-.23,1.48-.28.15-1,.2-1.28.41a2.65,2.65,0,0,0-1,1.8c0,1.73,1.37,2.85,2.29,4.32",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M415.15,202.08a4.17,4.17,0,0,0-4.36,1.17,2.22,2.22,0,0,0-.63,1.58,2,2,0,0,0,1.25,1.55,4.94,4.94,0,0,0,2.06.3,3.63,3.63,0,0,0,2.75-.85,2.33,2.33,0,0,0,.17-2.7,3.45,3.45,0,0,0-2.37-1.52",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M411.83,236.15h0a5.8,5.8,0,0,1-4.89-7.11c.43-1.82.79-3.3.79-3.3s-4.45-1.31-3.91-5.86c.3-2.57,1.12-6.72,1.79-9.87a7.8,7.8,0,0,1,5-5.75h0c5.56-1.58,7.42.71,11.5,4.8l.61.61-4.48,21.89A5.81,5.81,0,0,1,411.83,236.15Z",
    style: {
      fill: "#ffbe9d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M406.51,213a.66.66,0,1,0-.93-.17A.66.66,0,0,0,406.51,213Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M405.64,211.65c.06.09.55-.19,1.18-.11s1,.46,1.12.39,0-.18-.19-.36a1.48,1.48,0,0,0-.88-.41,1.52,1.52,0,0,0-1,.19C405.7,211.48,405.61,211.62,405.64,211.65Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M412.32,213.13a.67.67,0,1,0,.88.34A.67.67,0,0,0,412.32,213.13Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M412.18,213c.06.09.55-.19,1.18-.12s1,.47,1.12.4,0-.19-.19-.36a1.49,1.49,0,0,0-.89-.41,1.5,1.5,0,0,0-.95.19C412.24,212.81,412.15,212.94,412.18,213Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M409.11,218c0-.05-.36-.17-1-.34-.16,0-.29-.1-.29-.19a.94.94,0,0,1,.18-.45l.67-1.21a17.23,17.23,0,0,0,1.51-3.21,17.82,17.82,0,0,0-1.83,3l-.64,1.22a1.08,1.08,0,0,0-.18.67.45.45,0,0,0,.25.3.83.83,0,0,0,.27.07A2.92,2.92,0,0,0,409.11,218Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M407.73,225.67a10.7,10.7,0,0,0,6.16-.91s-1.84,3.09-6.32,2.09Z",
    style: {
      fill: "#eb996e"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M421.59,214.41c.1,0,3.76.31,2.5,3.66C423,221,420,219.41,420,219.31S421.59,214.41,421.59,214.41Z",
    style: {
      fill: "#ffbe9d"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M421.5,218.24s0,0,.12.11a.51.51,0,0,0,.38.12c.34,0,.74-.45.9-1a1.88,1.88,0,0,0,.06-.77.61.61,0,0,0-.28-.5.27.27,0,0,0-.34.05.73.73,0,0,0-.07.14s0-.07,0-.18a.27.27,0,0,1,.16-.15.39.39,0,0,1,.3,0,.73.73,0,0,1,.41.6,1.86,1.86,0,0,1,0,.87,1.38,1.38,0,0,1-1.1,1.06.59.59,0,0,1-.44-.21C421.49,218.31,421.49,218.24,421.5,218.24Z",
    style: {
      fill: "#eb996e"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M418.32,214.17a1.1,1.1,0,0,0,.32.92c.22.25.5.44.74.69a2.34,2.34,0,0,1,.63,1.42,3.17,3.17,0,0,0,.07.69.57.57,0,0,0,.49.43c.36,0,.52-.45.58-.81.25-1.51.49-3,.74-4.53l-3.65-1.59.21,2.55",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M410.74,203c.68-.18,1.48-.14,1.64.55a3.49,3.49,0,0,1-.35,2,5.78,5.78,0,0,0-.61,2,2.52,2.52,0,0,0,1.24,2.2,2.49,2.49,0,0,0,2.53-.06,8.49,8.49,0,0,0,.21,2.85,2.87,2.87,0,0,0,1.88,2,1.76,1.76,0,0,0,2.17-1.3,3,3,0,0,0,1,1.58,1.66,1.66,0,0,0,1.81.14,1.16,1.16,0,0,0,.32-1.67,2.14,2.14,0,0,0,2,1.37,1.81,1.81,0,0,0,1.72-1.59,1.59,1.59,0,0,0-1.53-1.68,3.17,3.17,0,0,0,1.65-.17,1.07,1.07,0,0,0,.58-1.39c-.33-.59-1.19-.51-1.8-.8-1-.48-1.15-1.79-1.47-2.84A7.12,7.12,0,0,0,419.8,202a11.55,11.55,0,0,0-5.85-.81c-1.3.12-2.8.58-3.21,1.82",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M408,210.72a.94.94,0,0,1-1,.21c-.38-.1-.72-.33-.76-.65s.44-.62,1-.47S408.16,210.46,408,210.72Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M414.32,211.87c-.23.22-.67.15-1.09.07s-.84-.21-1-.5,0-.34.25-.48a1.4,1.4,0,0,1,1.77.37C414.43,211.55,414.43,211.75,414.32,211.87Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M411.73,218.34c.1,0-.14.77-.93,1.23s-1.55.31-1.52.21.66-.13,1.33-.54S411.63,218.29,411.73,218.34Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M426.06,244.46c-3,10.76-8.08,28.35-10,32.17l-34.36-8.76,7.3-22.53a21.62,21.62,0,0,1,14.42-14.14l.22-.06c4.54-1.28,10.36-.62,15.71,1A10,10,0,0,1,426.06,244.46Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M383,263.79a3.55,3.55,0,0,1,.49,0l1.4.23,5.21.94,7.89,1.48,4.76.9,1.26.24a1.16,1.16,0,0,0,1-.29,4.21,4.21,0,0,0,1.1-2.23v0h0c.88-2.55,1.75-5.3,2.55-8.15.63-2.25,1.19-4.47,1.69-6.62s1.12-4.24.89-6.18a3.94,3.94,0,0,0-1.24-2.45,8.38,8.38,0,0,0-2.3-1.44,25.39,25.39,0,0,0-4.71-1.59,26.55,26.55,0,0,0-7.18-.65c-.85.05-1.51.11-2,.16a3.24,3.24,0,0,1-.69.05,4.31,4.31,0,0,1,.68-.15,19.52,19.52,0,0,1,2-.26,25.12,25.12,0,0,1,12.08,2,8.75,8.75,0,0,1,2.43,1.49,4.4,4.4,0,0,1,1.41,2.72,10,10,0,0,1-.2,3.18c-.2,1-.43,2.11-.68,3.19-.49,2.16-1.05,4.38-1.68,6.64-.81,2.87-1.68,5.62-2.57,8.17v0a4.73,4.73,0,0,1-1.28,2.51,1.73,1.73,0,0,1-1.41.39l-1.26-.25-4.76-.94-7.88-1.59-5.18-1.09-1.39-.31A1.54,1.54,0,0,1,383,263.79Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.7000000000000001
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M403.77,246.92a1.5,1.5,0,0,0,1.79,1.14,1.5,1.5,0,0,0-.64-2.93A1.51,1.51,0,0,0,403.77,246.92Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.7000000000000001
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M402.2,253.85a1.5,1.5,0,1,0,1.15-1.78A1.51,1.51,0,0,0,402.2,253.85Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.7000000000000001
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M400,260.75a1.5,1.5,0,1,0,1.15-1.79A1.51,1.51,0,0,0,400,260.75Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M393.32,244a35.4,35.4,0,0,1,8.31,1.78,17,17,0,0,1-4.21-.63A17.63,17.63,0,0,1,393.32,244Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M390.84,251a29,29,0,0,1,9.14,1.78,70.93,70.93,0,0,1-9.14-1.78Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M390,258.39a14.67,14.67,0,0,1,3.82.51,14.4,14.4,0,0,1,3.72,1,14.6,14.6,0,0,1-3.83-.51A14.25,14.25,0,0,1,390,258.39Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M420.3,232.49a2.19,2.19,0,0,0-1.35-2.13c-1.52-.79-12.27-1.11-12.27-1.11s-2.88.2-3.26,1.95Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M403.77,231.62c0-.07.86.29,2.29.42s3.45.19,5.65.29,4.2.09,5.64,0a15.35,15.35,0,0,1,2.35-.09,8.27,8.27,0,0,1-2.32.46,39.81,39.81,0,0,1-5.69.14c-2.22-.11-4.22-.24-5.68-.46A4.57,4.57,0,0,1,403.77,231.62Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M416.49,232.44c-.13-.08.06-.62,0-1.27s-.39-1.14-.28-1.25.69.33.8,1.18S416.6,232.53,416.49,232.44Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M412.71,232.81c-.12-.08.19-.69.26-1.48s-.11-1.45,0-1.52.58.61.49,1.57S412.81,232.91,412.71,232.81Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M408.5,232.19c-.14,0-.3-.71,0-1.55s.84-1.32.94-1.22-.21.65-.44,1.39S408.65,232.18,408.5,232.19Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M394.59,213.28a1.19,1.19,0,0,1,0-.32c0-.24-.07-.54-.11-.93a8.43,8.43,0,0,1-.09-1.52,14.18,14.18,0,0,1,.09-2.09,18.72,18.72,0,0,1,1.37-5.54,19.76,19.76,0,0,1,22.37-11.83,18.46,18.46,0,0,1,5.38,2,22.9,22.9,0,0,1,2.51,1.58,22.55,22.55,0,0,1,2.26,2,20,20,0,0,1,5.5,11.12,21.54,21.54,0,0,1-.14,6.37,19.06,19.06,0,0,1-2.06,5.84,21.64,21.64,0,0,1-1.61,2.56,22.08,22.08,0,0,1-2,2.22,18.66,18.66,0,0,1-4.61,3.38,19.92,19.92,0,0,1-10.24,2.29,19.88,19.88,0,0,1-14.54-7.45,18.64,18.64,0,0,1-2.86-4.94,14.77,14.77,0,0,1-.66-2,9.76,9.76,0,0,1-.34-1.49l-.15-.93a1,1,0,0,1,0-.31,1.31,1.31,0,0,1,.09.31c.05.23.12.53.2.91a10.13,10.13,0,0,0,.39,1.46,14.67,14.67,0,0,0,.7,1.95,18.56,18.56,0,0,0,2.9,4.83A19.61,19.61,0,0,0,413.2,230a19.58,19.58,0,0,0,10-2.28,18.56,18.56,0,0,0,4.5-3.32,20.89,20.89,0,0,0,1.91-2.16,21.43,21.43,0,0,0,1.57-2.5A19.33,19.33,0,0,0,428,197a20.29,20.29,0,0,0-2.2-2,19.65,19.65,0,0,0-2.44-1.55,18.46,18.46,0,0,0-5.24-1.94,19.61,19.61,0,0,0-10.23.58,19.29,19.29,0,0,0-7.61,4.74,19.6,19.6,0,0,0-4.16,6.16,18.92,18.92,0,0,0-1.44,5.45,14.43,14.43,0,0,0-.13,2.07,9,9,0,0,0,0,1.51c0,.39,0,.7.06.94A1.3,1.3,0,0,1,394.59,213.28Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M400.53,202.85a8,8,0,0,1,1.37-2.23,18.1,18.1,0,0,1,10.57-6.51,7.66,7.66,0,0,1,2.6-.22c0,.08-1,.18-2.51.58a21.06,21.06,0,0,0-5.68,2.4,21.28,21.28,0,0,0-4.7,4C401.14,202.06,400.61,202.89,400.53,202.85Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M399.59,206.13c-.14,0-.28-.52-.09-1.14s.61-1,.71-.89,0,.52-.21,1S399.74,206.12,399.59,206.13Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M482.56,268.93l7.12,1.19a6.5,6.5,0,0,0,7.13-4.07l7.1-18.29a6.5,6.5,0,0,0-5-8.77l-.92-.16a14.25,14.25,0,0,0-15.61,8.9l-4.82,12.43A6.51,6.51,0,0,0,482.56,268.93Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M611.71,298.43,619,309.38h0a33.86,33.86,0,0,1-24.27,27.05l-42.3,11.82-28.61.09L158.23,290.49l-22.25-8a23.55,23.55,0,0,1-15.29-26l2.64-15.9a5.7,5.7,0,0,1,4.79-4.7l1.7-.26s3.73-15.41,13.69-17.52c36.59-9.58,90.25-6.39,148.11-.07l38.46-11.94a204.94,204.94,0,0,1,55.5-9.1c1.44,1.85,2.94,3.62,4.08,5.28l.45.69a179.86,179.86,0,0,0-57.05,8.51l-38.64,14.76,195,25.69h0a8.26,8.26,0,0,1,9.56-8.86l45.7,7.61,6.54,6.44,49.93,10.82c4.42.91,14.66,7.75,10.55,30.5",
    style: {
      fill: "#FF725E"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M333.06,211.47A179.45,179.45,0,0,1,384,203.05c-2.32,3.14,2.42,6.25,2.5,6.78l-2,2a141.91,141.91,0,0,0-42.28,6.72l-27,10.32-20.8-2.62Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M141.3,236.29l-11.14-1.85c.89-2.95,3.67-10.72,9.12-14.48l14.66,2.44a3.52,3.52,0,0,1,2.11,5.74l-3.36,4A12.28,12.28,0,0,1,141.3,236.29Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M142.75,235.83c1.91-4.75,4.35-11,9-13.79l2.17.36a3.52,3.52,0,0,1,2.11,5.74l-3.36,4a12.25,12.25,0,0,1-10.18,4.3Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.7000000000000001
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M243.24,304a55.73,55.73,0,0,0,3.41-17.35c.87-25.22-12.65-45.53-37.12-49.6-21.29-3.54-40.94,7.11-48.28,31.26a64,64,0,0,0-2.62,22.26Z"
  }))), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.7000000000000001
    }
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M552.41,348.25c.11-.91.17-1.86.31-2.83,4.31-31.34-13.39-56.2-38.29-60.34a41.89,41.89,0,0,0-48.14,34.39c-1.15,6.94-2.48,13.44-2.53,19.34l60,9.53Z"
  }))), /*#__PURE__*/React.createElement("circle", {
    cx: 507.56,
    cy: 326.34,
    r: 36.45,
    transform: "translate(150.25 812.59) rotate(-86.43)",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M471.63,320.26l0,.09a36.45,36.45,0,0,0,71.91,12,.31.31,0,0,0,0-.1Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M482.32,322.14a25.59,25.59,0,1,0,29.44-21A25.58,25.58,0,0,0,482.32,322.14Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M511.76,301.1a25.59,25.59,0,0,0-29.44,21l50.48,8.4A25.59,25.59,0,0,0,511.76,301.1Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M492.18,323.78A15.59,15.59,0,1,0,510.12,311,15.6,15.6,0,0,0,492.18,323.78Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 203.58,
    cy: 281.17,
    r: 36.45,
    transform: "translate(-104.56 441.02) rotate(-81.51)",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M167.64,275.09a.29.29,0,0,1,0,.09,36.45,36.45,0,0,0,71.91,12,.28.28,0,0,0,0-.09Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M178.34,277a25.59,25.59,0,1,0,29.44-21A25.58,25.58,0,0,0,178.34,277Z",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M207.78,255.92a25.59,25.59,0,0,0-29.44,21l50.48,8.41A25.6,25.6,0,0,0,207.78,255.92Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M188.2,278.6a15.59,15.59,0,1,0,17.94-12.81A15.59,15.59,0,0,0,188.2,278.6Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "319.26 229.5 294.42 226.23 317.19 217.53 319.26 229.5",
    style: {
      fill: "#FF725E"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    points: "319.26 229.5 294.42 226.23 317.19 217.53 319.26 229.5"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M328.79,234.47l-10.27-1.71c-1.49-.24-2.26-3.07-1.72-6.32h0c.49-2.9,1.87-5.21,3.26-5.43l11.27-1.78Z",
    style: {
      fill: "#FF725E"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.4
    }
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M135.12,262.33c-.67,4-3.2,7-5.66,6.55s-3.9-4-3.23-8,3.2-7,5.66-6.56S135.79,258.3,135.12,262.33Z"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M611.71,298.43a3.34,3.34,0,0,1-.7-.05l-2-.23c-1.74-.22-4.25-.54-7.36-.89s-6.82-.73-10.94-1a93.41,93.41,0,0,0-13.42-.06,34.28,34.28,0,0,0-6.79,1.25,27.69,27.69,0,0,0-5.85,2.69,84,84,0,0,0-9,6.27,32.93,32.93,0,0,1-6.37,3.84,15.46,15.46,0,0,1-1.9.68,3.18,3.18,0,0,1-.69.17c0-.06.93-.3,2.51-1a35.58,35.58,0,0,0,6.23-4,79.49,79.49,0,0,1,9-6.39,27.59,27.59,0,0,1,5.93-2.75,32.89,32.89,0,0,1,6.9-1.28,90.09,90.09,0,0,1,13.5.09c4.14.32,7.85.73,10.95,1.14s5.62.77,7.35,1.05l2,.33A3.24,3.24,0,0,1,611.71,298.43Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.5
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M551.16,348.72l.48-.22a10.93,10.93,0,0,0,1.35-.71,12.66,12.66,0,0,0,4-4.19,19.36,19.36,0,0,0,2.53-8.85,64.36,64.36,0,0,0-.57-12.32A63.29,63.29,0,0,0,555.26,308a52.58,52.58,0,0,0-8.74-14.68,44.81,44.81,0,0,0-14.82-11.56A51,51,0,0,0,512.05,277a68.21,68.21,0,0,0-20.18,2.11A42.48,42.48,0,0,0,464,300.3,71.77,71.77,0,0,0,458,314c-.69,2.18-1.28,4.29-1.77,6.29a40.88,40.88,0,0,0-1.11,5.71c-.43,3.59.28,6.83,1.84,8.86a8.19,8.19,0,0,0,4.7,3.28,8.72,8.72,0,0,0,2,.12l-.52.07a6.41,6.41,0,0,1-1.54-.09,8.15,8.15,0,0,1-4.84-3.26c-1.63-2.06-2.38-5.37-2-9a40.71,40.71,0,0,1,1.08-5.76q.72-3,1.74-6.32a71.3,71.3,0,0,1,5.9-13.82,52.94,52.94,0,0,1,4.72-6.95,41.68,41.68,0,0,1,6.33-6.26,45.49,45.49,0,0,1,17.12-8.26,68.62,68.62,0,0,1,20.34-2.13,51.53,51.53,0,0,1,19.84,4.78,45.12,45.12,0,0,1,15,11.71,53,53,0,0,1,8.77,14.84,63,63,0,0,1,3.7,14.56,63.8,63.8,0,0,1,.5,12.39,19.41,19.41,0,0,1-2.65,8.94,12.47,12.47,0,0,1-4.16,4.17A7.84,7.84,0,0,1,551.16,348.72Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M273.9,299a5,5,0,0,1,0-.82c.05-.59.13-1.36.22-2.34.21-2.08.52-5,.89-8.59.81-7.29,1.92-17.28,3.15-28.32.67-5.5,1-10.85,2.54-15.5a24,24,0,0,1,3-6.17,38.75,38.75,0,0,1,3.66-4.74,32.12,32.12,0,0,1,6.57-5.62c.85-.56,1.55-.95,2-1.2a3.92,3.92,0,0,1,.74-.35,5.28,5.28,0,0,1-.68.44c-.46.28-1.14.7-2,1.28a33.9,33.9,0,0,0-6.41,5.69,40.35,40.35,0,0,0-3.56,4.74,23.21,23.21,0,0,0-2.95,6.08c-1.47,4.57-1.81,9.9-2.49,15.41-1.28,11-2.44,21-3.29,28.3-.45,3.58-.81,6.49-1.06,8.57-.13,1-.24,1.75-.32,2.33A4.22,4.22,0,0,1,273.9,299Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M257.39,296.25s.2,0,.59.06l1.73.23,6.67.95,24.49,3.56L371.65,313l35.92,5.37-.23.1a225,225,0,0,0,16.07-27.38,115.25,115.25,0,0,0,5.22-12.41,114,114,0,0,0,3.19-11.09,107.91,107.91,0,0,0,2.66-16.16c.16-1.9.21-3.37.23-4.36,0-.49,0-.86,0-1.13s0-.38,0-.38a3.79,3.79,0,0,1,0,.38c0,.25,0,.63,0,1.13,0,1,0,2.47-.15,4.37a103.77,103.77,0,0,1-2.53,16.22A111.65,111.65,0,0,1,429,278.8a114.66,114.66,0,0,1-5.19,12.47,223,223,0,0,1-16.05,27.49l-.08.12-.16,0-35.93-5.34-80.75-12.1-24.47-3.73-6.65-1-1.73-.29C257.58,296.3,257.39,296.25,257.39,296.25Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.30000000000000004
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M328.79,234.47l-10.27-1.71c-1.49-.24-2.26-3.07-1.72-6.32h0c.49-2.9,1.87-5.21,3.26-5.43l11.27-1.78Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M162,268.39a16.26,16.26,0,0,1-1-1.55,26.1,26.1,0,0,0-3-3.93,34.73,34.73,0,0,0-13.51-8.84,68.3,68.3,0,0,0-15.93-3.47c-2.08-.23-3.77-.39-4.94-.5a12.54,12.54,0,0,1-1.81-.23,1.75,1.75,0,0,1,.47,0l1.36.05c1.17,0,2.87.15,5,.34a62.64,62.64,0,0,1,16.07,3.35,33.54,33.54,0,0,1,13.6,9.07,23.56,23.56,0,0,1,2.88,4.08c.3.51.47.93.61,1.21S162,268.38,162,268.39Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M165.85,241.54c0,.14-8.62-1.18-19.21-2.94s-19.15-3.31-19.12-3.45,8.62,1.18,19.21,2.94S165.88,241.4,165.85,241.54Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.5
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M256.4,302.17s0-.17,0-.5.11-.83.19-1.45.18-1.43.26-2.36.19-2,.25-3.24a82.91,82.91,0,0,0-1.36-20.56A86.33,86.33,0,0,0,252,260.33a69.28,69.28,0,0,0-7.11-14.67A40.14,40.14,0,0,0,232,233.27,51.76,51.76,0,0,0,214,226.61a60.25,60.25,0,0,0-9.79-.77,62.92,62.92,0,0,0-9.49.9,56.94,56.94,0,0,0-8.89,2.39l-1.06.37-1,.43-2.05.86-2,1-1,.48-.94.54a51.36,51.36,0,0,0-12.8,10,56.09,56.09,0,0,0-8.27,11.54,58.19,58.19,0,0,0-4.51,10.83c-.44,1.67-.89,3.22-1.15,4.69s-.5,2.79-.67,4-.21,2.29-.31,3.22-.1,1.73-.11,2.37,0,1.11,0,1.46,0,.5,0,.5a4.68,4.68,0,0,1,0-.49c0-.36,0-.84,0-1.47s0-1.44.06-2.38.08-2,.27-3.24.31-2.57.63-4,.68-3,1.11-4.72a59,59,0,0,1,4.46-10.93,56.53,56.53,0,0,1,8.28-11.66,51.68,51.68,0,0,1,12.89-10.15l.94-.54,1-.49,2-1c.69-.29,1.38-.57,2.07-.87l1-.43,1.08-.38a56.47,56.47,0,0,1,9-2.42,62.82,62.82,0,0,1,9.58-.92,60.24,60.24,0,0,1,9.88.78,52,52,0,0,1,18.23,6.74,40.53,40.53,0,0,1,13,12.55,69.39,69.39,0,0,1,7.12,14.79A86.89,86.89,0,0,1,256.15,274a82.07,82.07,0,0,1,1.2,20.64A60.47,60.47,0,0,1,256.4,302.17Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M288.18,231.82a2.89,2.89,0,0,1-.39,0l-1.11-.18-4.28-.72c-3.72-.6-9.1-1.51-15.78-2.41s-14.65-1.88-23.52-2.69-18.65-1.42-28.93-1.75-20.07-.25-29-.14-17,0-23.69-.5a116.9,116.9,0,0,1-15.82-2.19c-1.85-.38-3.27-.75-4.22-1l-1.09-.3a1.91,1.91,0,0,1-.37-.12l.38.07,1.1.25c1,.24,2.39.57,4.24.92a123.74,123.74,0,0,0,15.81,2c6.72.46,14.74.53,23.66.39s18.72-.23,29,.09,20.07,1,28.95,1.81,16.85,1.83,23.53,2.79,12.05,1.92,15.76,2.58l4.27.82,1.1.23Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M455.46,326.09c0,.14-10.86-1.55-24.19-3.77s-24.13-4.13-24.1-4.28,10.85,1.55,24.19,3.77S455.48,325.94,455.46,326.09Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M551.44,257.41a1.9,1.9,0,0,1-.11.52c-.11.39-.26.87-.43,1.46-.37,1.28-.92,3.11-1.45,5.42a31.34,31.34,0,0,0-.86,8.19,17.48,17.48,0,0,0,3.22,9.38,24.5,24.5,0,0,0,7.45,6.69,43.48,43.48,0,0,0,7.52,3.47c2.22.81,4.05,1.37,5.31,1.78l1.45.48a1.74,1.74,0,0,1,.5.2,2.1,2.1,0,0,1-.53-.1l-1.48-.38c-1.27-.35-3.13-.86-5.38-1.63a42.22,42.22,0,0,1-7.63-3.4,24.64,24.64,0,0,1-7.64-6.81,17.67,17.67,0,0,1-3.27-9.66,30,30,0,0,1,1-8.3c.57-2.31,1.18-4.13,1.61-5.39.22-.63.39-1.11.52-1.44A2.2,2.2,0,0,1,551.44,257.41Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M612.47,293.74c-.58,2.57-3.46,1.84-6.63.38a9.84,9.84,0,0,1-4.77-13.34l0-.09a9.22,9.22,0,0,1,8.21-5l.71.08S614.25,285.88,612.47,293.74Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M412.82,253.26a1.35,1.35,0,0,1,.46,0,6.43,6.43,0,0,1,1.27.26,2.51,2.51,0,0,1,1.59,1.33,2.72,2.72,0,0,1-.2,2.72,4,4,0,0,1-2.91,1.63,11.77,11.77,0,0,1-3.78-.39l-8.4-1.76a7.3,7.3,0,0,1-2.2-.77,2.89,2.89,0,0,1-1.39-1.88,2.51,2.51,0,0,1,.76-2.14,3.51,3.51,0,0,1,1.89-1,12.46,12.46,0,0,1,3.81.19c1.16.18,2.24.38,3.22.57l4.63.91a13.42,13.42,0,0,1,1.7.35,1.2,1.2,0,0,1-.45,0c-.29,0-.72-.07-1.28-.14-1.11-.14-2.7-.41-4.67-.75-1-.16-2.06-.34-3.22-.5a11.62,11.62,0,0,0-3.64-.14,3,3,0,0,0-1.64.86,2,2,0,0,0-.61,1.7,2.37,2.37,0,0,0,1.16,1.52,6.32,6.32,0,0,0,2,.71l8.39,1.8a11.49,11.49,0,0,0,3.63.43,3.73,3.73,0,0,0,2.66-1.41,2.39,2.39,0,0,0,.23-2.39,2.29,2.29,0,0,0-1.39-1.26C413.44,253.38,412.81,253.32,412.82,253.26Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M440,249.69l-18.5-6.42c-3.92-1.21-5.56-1.36-5.94-4.33.55-4.74,2.54-6.83,6-6.14-.14-.83,19.78,5.78,28.16,8.6a8.13,8.13,0,0,1,5,4.83h0",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M440,249.74a5.3,5.3,0,0,1,.7-2.33,9.43,9.43,0,0,1,4.11-4.17,9.24,9.24,0,0,1,5.8-.82,5.47,5.47,0,0,1,2.29.84c0,.09-.89-.29-2.34-.47a9.6,9.6,0,0,0-5.51.91,9.86,9.86,0,0,0-4,3.89C440.3,248.86,440.09,249.77,440,249.74Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M421.7,241.78a99.49,99.49,0,0,1,9.88,2.36,98.21,98.21,0,0,1,9.74,2.87,98,98,0,0,1-9.88-2.37A100,100,0,0,1,421.7,241.78Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.2
    }
  }, _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M437.9,249.27a4.12,4.12,0,0,1,1.43-4.31,7.94,7.94,0,0,1,4.91-1.27,10.81,10.81,0,0,0-4.31,6Z"
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M429.38,263.79l0,0a63.1,63.1,0,0,1-5.77,3.75c-2.83,1.47-3,1.22-3.08.86-.31-1,4.87-2.77,3.53-3s-6.07,3-6.36,1.93c-.36-1.33,5.1-3.12,5.55-3.31s.19-.84-.2-.65c-.58.27-6.65,3-7,1.69-.2-.72,1.13-1,1.13-1s5.87-2.13,5.67-2.73-3.69.51-4.84,1-1.81.11-1.6-.57c.15-.45,3.64-2,4.79-2.39s4.31-1.56,2.3-2.28-3.3-2-3.4-2.61a.67.67,0,0,1,1.17-.49,7.73,7.73,0,0,0,1.86,1.09,5.11,5.11,0,0,0,1.67.45c.67.06,1.25.09,1.73.09a3,3,0,0,1,2.1.86c.77.88,2,6.4,2,6.4Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M429.24,254.61l3.18,8A1.14,1.14,0,0,1,432,264l0,0a1.15,1.15,0,0,1-1.65-.56l-3.13-8.05a1.14,1.14,0,0,1,.4-1.34h0A1.13,1.13,0,0,1,429.24,254.61Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M428.83,254l3,8.48L451.68,255a6,6,0,0,0,3.4-8.11l-1.48-2.72Z",
    style: {
      fill: "#455a64"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M430.34,258.29c0-.08,1.42-.49,3.71-1.29s5.41-2,8.83-3.41,6.52-2.72,8.79-3.59c1.13-.43,2.05-.77,2.7-1a4.48,4.48,0,0,1,1-.28,4.53,4.53,0,0,1-.95.47l-2.64,1.14c-2.23,1-5.29,2.31-8.72,3.73s-6.59,2.58-8.92,3.28c-1.16.36-2.11.61-2.78.76A3.77,3.77,0,0,1,430.34,258.29Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M418.08,242.48a3.52,3.52,0,0,1-.39-1.59,9.24,9.24,0,0,1,2.73-7.25c.75-.7,1.31-1,1.35-.94s-.44.46-1.08,1.2a10.67,10.67,0,0,0-1.95,3.25,10.87,10.87,0,0,0-.68,3.72A10.17,10.17,0,0,1,418.08,242.48Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M409.48,232.53a34.92,34.92,0,0,1-2.6,3,35,35,0,0,1-2.53,3,14.05,14.05,0,0,1,5.13-6Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M402.49,233.66a.81.81,0,1,0,.2-.08",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M401.15,235.48a.81.81,0,1,0,.2-.08",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M409.81,234.86a.27.27,0,0,1,0,.38.26.26,0,0,1-.37,0,.27.27,0,0,1,0-.38A.28.28,0,0,1,409.81,234.86Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M408.07,237.52a.24.24,0,0,1,0,.32.26.26,0,0,1-.32-.07c-.09-.11-.11-.25,0-.32A.22.22,0,0,1,408.07,237.52Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.5
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M347.38,233.24s-32.32,33.87-32.33,52.63c0,0,9.47-7.1,14.38-7.37,0,0-11.55,9.75-12.39,33.15,0,0,21.55-38.8,46.83-49.24,0,0-18.76,4.69-23.32,7.38,0,0,24.92-25.38,40.62-32Z",
    style: {
      fill: "#fff"
    }
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCar);
export default __webpack_public_path__ + "static/media/car.e9ad9f999e7e60a6f66e2c9f588f2c4a.svg";
export { ForwardRef as ReactComponent };